import type { GatewayUserSettings } from './interfaces/gatewayUserSettings.interface'

export function serializeGatewayUserSettingsKey(settings: GatewayUserSettings): string {
  return JSON.stringify({
    useCustom: settings.useCustom,
    host: settings.host ?? '',
    httpPort: settings.httpPort ?? '',
    wsPort: settings.wsPort ?? '',
    mcpPort: settings.mcpPort ?? '',
  })
}
